import { filterFieldsType, activeShipmentsFilter } from '../../../state/ducks/allShipmentsPage/allShipmentsPage';

export type OversightFilterPreset =
    | 'notInvoiced'
    | 'deliveredNotInvoiced'
    | 'readyToIssue'
    | 'overdue'
    | 'waitingVendorInvoice'
    | 'waitingCustomsCharges'
    | 'waitingTransportInvoice'
    | 'waitingOpsApproval'
    | 'deliveredWithoutInvoice'
    | 'negativeProfit'
    | 'cargoOwnerAll';

const NOT_INVOICED_ACCOUNTING_STATES = [
    'WATING_PRICING',
    'NO_INTERNAL_PRICING',
    'WATING_OPERATOR',
    'WAITING_ORDER_NUMBER',
    'READY_FOR_CHARGE',
    'READY_TO_ISSUE'
];

export function buildOversightShipmentsFilter(
    preset: OversightFilterPreset,
    cargoOwnerId?: string | null
): filterFieldsType {
    const base: filterFieldsType = [activeShipmentsFilter];
    if (cargoOwnerId && cargoOwnerId !== '__ALL__') {
        base.push({ field: 'businessPartner', value: cargoOwnerId });
    }

    switch (preset) {
        case 'notInvoiced':
            return [...base, { field: 'accountingState', value: NOT_INVOICED_ACCOUNTING_STATES }];
        case 'deliveredNotInvoiced':
            return [
                ...base,
                { field: 'state', value: ['DELIVERED'] },
                { field: 'accountingState', value: NOT_INVOICED_ACCOUNTING_STATES }
            ];
        case 'readyToIssue':
            return [...base, { field: 'accountingState', value: ['READY_TO_ISSUE'] }];
        case 'waitingVendorInvoice':
            return [...base, { field: 'accountingState', value: ['WATING_PRICING'] }];
        case 'waitingCustomsCharges':
            return [...base, { field: 'accountingState', value: ['READY_FOR_CHARGE'] }];
        case 'waitingTransportInvoice':
            return [...base, { field: 'accountingState', value: ['WATING_OPERATOR'] }];
        case 'waitingOpsApproval':
            return [...base, { field: 'accountingState', value: ['WAITING_ORDER_NUMBER', 'NO_INTERNAL_PRICING'] }];
        case 'deliveredWithoutInvoice':
            return [
                ...base,
                { field: 'state', value: ['DELIVERED'] },
                { field: 'accountingState', value: NOT_INVOICED_ACCOUNTING_STATES }
            ];
        case 'negativeProfit':
        case 'overdue':
        case 'cargoOwnerAll':
        default:
            return base;
    }
}

export const OVERSIGHT_FILTER_LABELS: Record<OversightFilterPreset, string> = {
    notInvoiced: 'Not invoiced',
    deliveredNotInvoiced: 'Delivered · not invoiced',
    readyToIssue: 'Ready to issue',
    overdue: 'Overdue collections',
    waitingVendorInvoice: 'Waiting for vendor invoice',
    waitingCustomsCharges: 'Waiting for customs charges',
    waitingTransportInvoice: 'Waiting for transport invoice',
    waitingOpsApproval: 'Waiting for ops approval',
    deliveredWithoutInvoice: 'Delivered without invoice',
    negativeProfit: 'Negative profit',
    cargoOwnerAll: 'All cargo owner shipments'
};
